import {
  user_shoutouts_returned,
  user_profile_opened,
  new_shoutout_received,
  profile_shoutouts_requested,
  all_profile_shoutouts_loaded,
  profile_shoutout_returned,
  change_filter,
  shoutout_deleted,
  shoutout_updated,
  comment_received,
  comment_deleted
} from '../actions/types';

const INITIAL_STATE = {
  id: null,
  shoutouts: [],
  after: '',
  shoutoutsLoading: false,
  allShoutoutsLoaded: false,
  singleNotReturned: false,
  shoutoutFilter: 'Received'
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case user_profile_opened:
      return { ...INITIAL_STATE, id: action.payload };

    case profile_shoutouts_requested:
      return { ...state, shoutoutsLoading: true };

    case new_shoutout_received: {
      const shoutout = action.payload;
      switch (state.shoutoutFilter){
        case 'Received':
          if (shoutout.recipients.filter(recipient => recipient.uid === state.id).length > 0) {
            return { ...state, shoutouts: [action.payload, ...state.shoutouts] };
          }
          return state;
        case 'Sent':
          if (shoutout.sender.uid === state.id) {
            return { ...state, shoutouts: [action.payload, ...state.shoutouts] };
          }
          return state;
        case 'Sent & Received':
          if (shoutout.recipients.filter(recipient => recipient.uid === state.id).length > 0) {
            return { ...state, shoutouts: [action.payload, ...state.shoutouts] };
          } else if (shoutout.sender.uid === state.id) {
            return { ...state, shoutouts: [action.payload, ...state.shoutouts] };
          } else {
            return state;
          }
        default:
          return state;
      }
    }

    case user_shoutouts_returned: {
      const newShoutouts =  [...state.shoutouts, ...action.payload.shoutouts];
      const found = [];

      return { ...state,
        after: action.payload.after,
        shoutouts: newShoutouts.filter((shoutout)=> {
          if (found.indexOf(shoutout._id) === -1){
            found.push(shoutout._id);
            return true;
          }
          return false;
        }),
        shoutoutsLoading: false
      };
    }

    case all_profile_shoutouts_loaded:
      return { ...state, allShoutoutsLoaded: true };

    case profile_shoutout_returned:
      if (action.payload) {
        return { ...state, shoutouts: [...state.shoutouts, action.payload] };
      } else {
        return { ...state, singleNotReturned: true };
      }
    case change_filter: {
      return { ...state, shoutouts: [], after: '', allShoutoutsLoaded: false, shoutoutsLoading: false, shoutoutFilter: action.payload };
    }
    case shoutout_deleted: {
      let shoutouts = [ ...state.shoutouts ];
      let shoutout =  shoutouts.find((so) => so._id === action.payload._id);
      let index = shoutouts.indexOf(shoutout);
      shoutouts.splice(index, 1);
      return { ...state, shoutouts };
    }

    case shoutout_updated: {
      let shoutouts = [ ...state.shoutouts ];
      let index = shoutouts.indexOf(shoutouts.filter((shoutout) => shoutout._id === action.payload.id)[0]);
      if (index !== -1) shoutouts[index].message = action.payload.text;
      return { ...state, shoutouts: [ ...shoutouts ] };
    }

    case comment_received: {
      const comment = action.payload;

      for (let i in state.shoutouts) {
        if (state.shoutouts[i]._id === comment.shoutout_id) {
          state.shoutouts[i].comments.push(comment._id);
          break;
        }
      }

      return { ...state, shoutouts: [...state.shoutouts] };
    }

    case comment_deleted: {
      let index;
      const shoutout = state.shoutouts.find((shoutout, i) => {
        if (shoutout._id === action.payload.shoutout_id) {
          index = i;
          return true;
        }

        return false;
      });

      if (shoutout) {
        const commentIndex = shoutout.comments.indexOf(action.payload.id);
        shoutout.comments.splice(commentIndex, 1);
        state.shoutouts[index] = { ...shoutout };
      }

      return { ...state, shoutouts: [...state.shoutouts] };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ProfileReducer.js